import { merge as lodashMerge } from 'lodash-es';

export const merge = (...args: Object[]) => {
  return lodashMerge({}, ...args);
};
